var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('vl-layer-vector',{attrs:{"zIndex":20}},[_c('vl-source-vector',{attrs:{"ident":"bases","features":_vm.bases}},[_c('vl-style-func',{attrs:{"function":_vm.styleFunc()}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }